<mat-card style="border-color: #5775a8;">
  <mat-card-header class="">
    <div class="flex flex-row rounded-lg w-full" style="align-items: baseline;">
      <div class="flex flex-col w-1/2" style="padding-right: 20px;">
        <div class="flex flex-row w-full">
          <span style="font-size: larger;">
            {{currentBusiness.businessName}}
          </span>
          &nbsp; <mat-icon matTooltip="Edit" (click)="editBusiness()">edit</mat-icon>
        </div>
        <hr style="border: 1px solid gray;">
      </div>

      <div class="flex flex-col w-1/2" style="align-items: baseline;">
        <span style="font-size: larger;">
          Registered Agent
        </span>
        <hr class="w-full" style="border: 1px solid gray;">
      </div>
    </div>
  </mat-card-header>

  <mat-card-content>
    <mat-card>

        <div class="flex flex-row rounded-lg w-full" style="align-items: baseline;">

          <div class="flex flex-col w-1/2" style="padding-right: 20px;">
            <div class="flex flex-row w-full">
              <div class="flex flex-col w-full">
                <span>
                  {{currentBusiness.businessAddress1}}
                </span>
                <span>{{currentBusiness.businessCity + ' ' +
                  currentBusiness.businessZip}}</span>
              </div>
              <div class="flex flex-col w-1/4">
                <!-- <a (click)="refresh()"><mat-icon matTooltip="Refresh" (click)="refresh()">refresh</mat-icon> Refresh</a> -->
                <div style="vertical-align: middle;">
                  <a (click)="refresh()" style="display: flex; align-items: center;">
                    <mat-icon matTooltip="Refresh" style="transform: scale(.7);">refresh</mat-icon> Refresh
                  </a>
                </div>
                <!-- <a (click)="refresh()">
                  <mat-icon matTooltip="Refresh" style="transform: scale(.7);">refresh</mat-icon>
                  <span>Refresh</span> 
                </a>   -->

                <a *ngIf="isAdmin" (click)="admin()" style="display: flex; align-items: center;"><mat-icon matTooltip="Admin"
                    style="transform: scale(.7);vertical-align: bottom;">settings</mat-icon> Admin</a>
              </div>
            </div>

            <table class="w-full">
              <tr style="padding-bottom: 10px;">
                <th>Business ID:</th>
                <td>{{currentBusiness.id}} </td>
              </tr>
              <tr>
                <th>Type:</th>
                <td>{{businessType(currentBusiness.businessType)}} 
                </td>
              </tr>
              <tr>
                <th>Status: </th>
                <td>
                  <span *ngIf="currentBusiness.active" style="color: green;">Active</span>
                  <span *ngIf="!currentBusiness.active" style="color: red;">Inactive</span>
                </td>
              </tr>
              <tr style="padding-bottom: 10px;">
                <th>Exempt:</th>
                <td>
                  <span *ngIf="!currentBusiness.exempt" style="color: red;font-weight: bold;">No</span>
                  <div *ngIf="currentBusiness.exempt">
                    <span style="display: flex; align-items: center; justify-content: left;color:green;font-weight: bold;"> Yes <mat-icon matTooltip="Info" (click)="showInfo()">info-sign</mat-icon>
                    </span>
                    <table *ngIf="showInformation" class="w-full">
                      <tr style="border-bottom: 1px;color: grey; ">
                        <th style="color:green;">Certification Date:</th>
                        <td style="color:green;">{{currentBusiness.exemptCertificateDate}} </td>
                      </tr>
                      <tr style="border-bottom: 1px;color: grey; ">
                        <th style="color:green;">Status:</th>
                        <td style="color:green;">{{currentBusiness.exemptStatus}} </td>
                      </tr>
                      <tr style="border-bottom: 1px;color: grey; ">
                        <th style="color:green;">Type:</th>
                        <td style="color:green;">{{currentBusiness.exemptType}} </td>
                      </tr>
                      <tr>
                        <th style="color:green;">Cigarette Smoking Allowed:</th>
                        <td>
                          <span *ngIf="currentBusiness.exemptSmokingAllowed" style="color:green;">Yes</span> 
                          <span *ngIf="!currentBusiness.exemptSmokingAllowed" style="color:red;">No</span> 
                        </td>
                      </tr>
                    </table>
                  </div>
                </td>
              </tr>

              <tr style="padding-bottom: 10px;">
                <th>County:</th>
                <td>{{currentBusiness.countyName}} </td>
              </tr>
              <tr style="padding-bottom: 10px;">
                <th>Business Phone:</th>
                <td>{{currentBusiness.businessPhone + ' ' + 
                  (currentBusiness.businessPhoneExt != null && currentBusiness.businessPhoneExt != '' ? ' +' + currentBusiness.businessPhoneExt : '')}} 
                  </td>
              </tr>
              <tr *ngIf="currentBusiness.contactTitle != null && currentBusiness.contactTitle.length > 0" style="padding-bottom: 10px;">
                <th>Contact Title:</th>
                <td>{{currentBusiness.contactTitle}} </td>
              </tr>
              <tr *ngIf="currentBusiness.contactEmail != null && currentBusiness.contactEmail.length > 0" style="padding-bottom: 10px;">
                <th>Contact Email:</th>
                <td>{{currentBusiness.contactEmail}} </td>
              </tr>

              <tr *ngIf="currentBusiness.businessOwner != null && currentBusiness.businessOwner.length > 0" style="padding-bottom: 10px;">
                <th>Business Owner:</th>
                <td>{{currentBusiness.businessOwner}} </td>
              </tr>

              <tr *ngIf="currentBusiness.businessOwnerTitle != null && currentBusiness.businessOwnerTitle.length > 0" style="padding-bottom: 10px;">
                <th>Owner Title:</th>
                <td>{{currentBusiness.businessOwnerTitle}} </td>
              </tr>
              <tr *ngIf="currentBusiness.businessOwnerPhone != null && currentBusiness.businessOwnerPhone.length > 0" style="padding-bottom: 10px;">
                <th>Owner Phone:</th>
                <td>{{currentBusiness.businessOwnerPhone}} </td>
              </tr>
              <tr *ngIf="currentBusiness.businessOwnerEmail != null && currentBusiness.businessOwnerEmail.length > 0" style="padding-bottom: 10px;">
                <th>Owner Email:</th>
                <td>{{currentBusiness.businessOwnerEmail}} </td>
              </tr>

            </table>

          </div>

          <div class="flex flex-col w-1/2" style="padding-right: 20px;">
            <span *ngIf="!registeredAgentFlag">
              No Registered Agent
            </span>
            <table class="w-full" *ngIf="registeredAgentFlag">
              <tr *ngIf="currentBusiness.id != null && currentBusiness.id > 0" style="padding-bottom: 10px;">
                <th>Registered Agent ID:</th>
                <td>{{currentBusiness.id}} </td>
              </tr>
              <tr *ngIf="currentBusiness.parentBusinessName != null && currentBusiness.parentBusinessName.length > 0" style="padding-bottom: 10px;">
                <th>Registered Agent Name:</th>
                <td>{{currentBusiness.parentBusinessName}}</td>
              </tr>
              <tr *ngIf="currentBusiness.businessOwnerEmail != null && currentBusiness.businessOwnerEmail.length > 0"style="padding-bottom: 10px;">
                <th>Registered Agent Name:</th>
                <td>{{businessType(currentBusiness.businessType)}} 
                </td>
              </tr>

              <tr *ngIf="(currentBusiness.parentBusinessContactFirstName != null && currentBusiness.parentBusinessContactFirstName.length > 0) ||
                (currentBusiness.parentBusinessContactLastName != null && currentBusiness.parentBusinessContactLastName.length > 0)" style="padding-bottom: 10px;">
                <th>Contact Name:</th>
                <td>{{currentBusiness.parentBusinessContactFirstName}} {{currentBusiness.parentBusinessContactLastName}} </td>
              </tr>

              <tr *ngIf="currentBusiness.parentBusinessContactTitle != null && currentBusiness.parentBusinessContactTitle.length > 0" style="padding-bottom: 10px;">
                <th>Contact Title:</th>
                <td>{{currentBusiness.parentBusinessContactTitle}} </td>
              </tr>
              <tr *ngIf="currentBusiness.parentBusinessAddress != null && currentBusiness.parentBusinessAddress.length > 0" style="padding-bottom: 10px;">
                <th>Address:</th>
                <td>{{currentBusiness.parentBusinessAddress}} </td>
              </tr>
              <tr *ngIf="currentBusiness.parentBusinessAddress2 != null && currentBusiness.parentBusinessAddress2.length > 0" style="padding-bottom: 10px;">
                <th>Address 2:</th>
                <td>{{currentBusiness.parentBusinessAddress2}} </td>
              </tr>
              <tr *ngIf="currentBusiness.parentBusinessCity != null && currentBusiness.parentBusinessCity.length > 0" style="padding-bottom: 10px;">
                <th>City:</th>
                <td>{{currentBusiness.parentBusinessCity}} </td>
              </tr>
              <tr *ngIf="currentBusiness.parentBusinessState != null && currentBusiness.parentBusinessState.length > 0" style="padding-bottom: 10px;">
                <th>State:</th>
                <td>{{currentBusiness.parentBusinessState}} </td>
              </tr>
              <tr *ngIf="currentBusiness.parentBusinessZip != null && currentBusiness.parentBusinessZip.length > 0" style="padding-bottom: 10px;">
                <th>Zip:</th>
                <td>{{currentBusiness.parentBusinessZip}} 
                  <span *ngIf="currentBusiness.parentBusinessZipExt != null && currentBusiness.parentBusinessZipExt.length > 0">Ext. {{currentBusiness.parentBusinessZipExt}}</span>
                </td>
              </tr>

              <tr *ngIf="currentBusiness.parentBusinessPhone != null && currentBusiness.parentBusinessPhone.length > 0" style="padding-bottom: 10px;">
                <th>Phone:</th>
                <td>{{currentBusiness.parentBusinessPhone}} 
                  <span *ngIf="currentBusiness.parentBusinessPhoneExt != null && currentBusiness.parentBusinessPhoneExt.length > 0">Ext. {{currentBusiness.parentBusinessPhoneExt}}</span>
                </td>
              </tr>
              <tr *ngIf="currentBusiness.parentBusinessEmail != null && currentBusiness.parentBusinessEmail.length > 0" style="padding-bottom: 10px;">
                <th>Email:</th>
                <td>{{currentBusiness.parentBusinessEmail}} </td>
              </tr>
            </table>

          </div>
        </div>
        <br />

    </mat-card>
    <br />

  </mat-card-content>

</mat-card>